export const actionOptions = {
  "actions": [
    {
      title: "Release Order",
      cls: "release-order",
      icon: "hourglass",
      disabled:false
    }
  ]
};



// WEBPACK FOOTER //
// ./src/pages/releaseOrders/filter/actionOptions.js